module.exports = __webpack_public_path__ + "img/dsci0025.4b41abc8.jpg";